import React from 'react';
import { Form } from 'antd';
import { QUERY_KEYS } from '@/utils/query-keys';
import { useUpdateDataExtraction } from '@/hooks';
import { useQueryClient } from '@tanstack/react-query';
import { useDataExtractionReport } from '@/context/DataExtractionReport';
import { StepFooterButtons } from '@/components/Settings/DataExtraction/components/StepFooterButtons';

const { useFormInstance } = Form;

export function Footer() {
	const form = useFormInstance();
	const queryClient = useQueryClient();
	const { isLoading, mutateAsync: updateDataExtraction } = useUpdateDataExtraction();
	const { dataExtractionReport, onNextStep, onPreviousStep } = useDataExtractionReport();

	async function handleOnSubmit(): Promise<void> {
		if (!dataExtractionReport?.id) return;

		try {
			const formValues = await form.validateFields();

			const selectedToolIds = formValues?.tools?.selected_tools || [];

			const updatePayload = {
				id: dataExtractionReport.id,
				organization_id: dataExtractionReport.organization_id,
				company_id: dataExtractionReport.company_id,
				ergonomic_tool_ids: selectedToolIds,
				current_step_sequence: 3
			};

			await updateDataExtraction(updatePayload);
			await queryClient.invalidateQueries([QUERY_KEYS.GET_DATA_EXTRACTION]);

			onNextStep();
		} catch (error) {
			console.error('Error saving tools:', error);
		}
	}

	function handleOnCancel(): void {
		onPreviousStep();
	}

	return <StepFooterButtons isLoadingNextButton={isLoading} onSubmit={handleOnSubmit} onCancel={handleOnCancel} />;
}
